import { Line } from "@vds/lines";
import { Loader } from "@vds/loaders";
import { DropdownSelect } from "@vds/selects";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ChildContainer,
  FloorImage,
  FloorPlanText,
  FloorPreviewContainer,
  FloorText,
  LoaderContainer,
} from "../../global/components/OnboardingFormStyles/Styles";
import { ImageDownloadMedia } from "../../model/mediaService";
import {
  getSiteSelected,
  saveFloorImageMapping,
  setFloorSelected,
} from "../../store/actions";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";

const SelectFloorPlan = ({ onImageDownloadFailed }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isImageDownloadFailed, setIsImageDownloadFailed] = useState(false);
  const siteTagList = useSelector((state) => {
    return state.sitesReducer.siteTagList;
  });
  const [allFloors, setAllFloors] = useState([]);
  const dispatch = useDispatch();
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const { companionSelected, floorSelected } = useSelector(
    (state) => state.cameraonboardingReducer
  );
  const { companionDeviceList } = useSelector((state) => state?.deviceReducer);

  const cachedFloorImages = useSelector(
    (state) => state?.imagesReducer?.floorImages
  );
  // load image for the first time when selected
  useEffect(() => {
    if (floorSelected?.id && !floorSelected?.imageurl) {
      handleFloorChange(floorSelected?.id);
    }
  }, [dispatch && floorSelected?.id && allFloors]);

  const fetchFloorImage = async (imageId) => {
    try {
      setIsLoading(true);
      onImageDownloadFailed(false);
      const imageUrl = await ImageDownloadMedia(imageId, activeSession);

      if (!imageUrl) {
        onImageDownloadFailed(true);
        setIsLoading(false);
        return null;
      }
      setIsLoading(false);
      return imageUrl;
    } catch (error) {
      console.error("Error downloading image:", error);
      onImageDownloadFailed(true);
      setIsLoading(false);
      return null;
    }
  };

  const handleFloorChange = async (selectedFloorId) => {
    const selectedFloor = allFloors.find(
      (floor) => floor.id === selectedFloorId
    );
    if (!selectedFloor || !selectedFloor.imageid) {
      console.error("Selected floor or image ID is not available");
      return;
    }
    const matchingFloorImageTag = cachedFloorImages?.find(
      (floor) => floor.id === selectedFloorId
    );
    if (!matchingFloorImageTag) {
      try {
        const floorImageUrl = await fetchFloorImage(selectedFloor?.imageid);
        dispatch(saveFloorImageMapping(selectedFloorId, floorImageUrl));
        dispatch(
          setFloorSelected({
            name: selectedFloor?.name,
            id: selectedFloorId,
            imageid: selectedFloor?.imageid,
            imageurl: floorImageUrl,
          })
        );
        dispatch(getSiteSelected({ name: "", id: "" }));
      } catch (error) {
        console.error("Error fetching floor image:", error);
      }
    } else {
      dispatch(
        setFloorSelected({
          name: selectedFloor?.name,
          id: matchingFloorImageTag.id,
          imageid: selectedFloor?.imageid,
          imageurl: matchingFloorImageTag.imageUrl,
        })
      );
    }
  };

  useEffect(() => {
    (async () => {
      // resest floor listing
      //setAllFloors([]);
      try {
        if (companionSelected.id) {
          const companionDeviceDetails = companionDeviceList.find(
            (copmanion) => copmanion.id == companionSelected.id
          );
          if (
            companionDeviceDetails &&
            companionDeviceDetails?.siteids?.length
          ) {
            const siteIds = companionDeviceDetails?.siteids;

            // const floorData = await Promise.all(
            //   siteIds.map(async (siteId) => {
            //     const hierarchyData = await getTagHierarchy(
            //       { maxdepth: 1 },
            //       { id: siteId },
            //       activeSession
            //     );
            //     return hierarchyData;
            //   })
            // );

            const floorData = siteTagList?.floors.filter((f) => {
              try {
                return f.tagids && siteIds.indexOf(f.tagids[0]) > -1;
              } catch (error) {
                return false;
              }
            });

            if (floorData?.length) {
              setAllFloors(floorData.flat());
            }
          }
        }
      } catch (error) {
        console.error("Error fetching site list:", error);
      }
    })();
  }, [companionSelected]);

  return (
    <ChildContainer>
      <Line type="secondary" />
      <FloorText>
        Select the floor plan that corresponds with the location of the camera.
      </FloorText>

      <FloorPreviewContainer>
        <DropdownSelect
          label="Floor plan"
          onChange={(e) => handleFloorChange(e.target.value)}
          data-testid={CAMERA_ONBOARDING_TEST_IDS.FLOOR_PLAN_DROPDOWN}
          readOnly={false}
          required={true}
          inlineLabel={false}
          width="328px"
        >
          <option></option>
          {allFloors &&
            allFloors.map((floor) => (
              <option
                selected={floorSelected?.id === floor?.id}
                key={floor.id}
                value={floor.id}
              >
                {floor.name}
              </option>
            ))}
        </DropdownSelect>

        {floorSelected && (
          <div>
            {!isLoading && floorSelected?.imageurl && (
              <FloorPlanText>Floor plan preview</FloorPlanText>
            )}
            {isLoading && (
              <LoaderContainer>
                <Loader fullscreen={false} active={isLoading} />
              </LoaderContainer>
            )}
            {!isLoading && floorSelected?.imageurl && (
              <FloorImage src={floorSelected?.imageurl} alt="Floor Image" />
            )}
          </div>
        )}
      </FloorPreviewContainer>
    </ChildContainer>
  );
};

export default SelectFloorPlan;
